module.exports = __webpack_public_path__ + "static/media/sms.53037243.png";